import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./../globalCSS/querytype/customquery.css";
import { useNavigate } from "react-router-dom";
import Header from "../header";
import Popupaddparameter from "./Popupaddparameter";
import PopupremoveDateParameter from "./PopupremoveDateParameter";
import {
  testquryonCustompage,
  resettestquryonCustompage,
  resetbacktocustomquerypagewithdata,
} from "../../actions/auth";
import { Button } from "./../globalCSS/Button/Button";
import { toast } from "react-toastify";
import {
  getreporttitlefromondashbaord,
  texttoquerychartbotreset,
  setDrilldownTypeCheckdashboard,
} from "../../actions/reportmanagement";
import ChatBotModal from "./ChatBotModal";
import bot from "../Images/bot.png";
import { decryptData } from "../utils/EncriptionStore";
import charts from './ChartGallery';


export default function ReportPage(props) {
  const insitialval = {
    title: "",
    query: "",
    start_date: "",
    end_date: "",
    type: "",
    chart_type: "",
    time_period: "",
    background_colour: "",
    chart_react_colour: "",
    font_size_title: "",
    font_size_value: "",
    layout: "",
    layout_value: "",
    gradient_mode: "",
    subtitle: "",
    subtitle_size: "",
    subtitle_color: "",
    text_alignment: "",
    upload_logo: "",
    image_size: "",
    chart_colours: "",
    enable_drilldown: "no",
    enable_range_filter: "no",
    drilldown_type: "",
    update_interval: "",
    report_id: "",
    connection_type: "",
    schema: "",
    chart_subtitle: "",
    enable_labels: "",
    custombox_background_colour: "",
    custombox_title_font_size: "",
    custombox_value_font_size: "",
    custombox_font_colour: "",
    custombox_legend_font_colour: "",
    custombox_legend_position: "",
    display_title: "",
  };

  const handleClose = () => {
    dispatch(texttoquerychartbotreset());
    setShowModal(true);
  };

  const renderCharts = (chartList) =>
    chartList.map((chart) => (
      <div
        key={chart.id}
        style={{ cursor: "pointer" }}
      >
        <input
          className="radBut"
          type="radio"
          id={chart.id}
          name="chart_type"
          value={chart.value}
          onChange={handleRadioChange}
          title={chart.title}
        />
        <label htmlFor={chart.id} className="radio-inline">
          <img className="charts_img" src={chart.imageUrl} alt={chart.title} />
        </label>
      </div>
    ));

  const [showModal, setShowModal] = useState(false);
  const [show, setShow] = useState(false);
  const [showLogoSection, setShowLogoSection] = useState(false);
  const [formdata, setformdata] = useState(insitialval);
  const [enableDrilldown, setEnableDrilldown] = useState("no");
  const [enablerangefilter, setEnableRangeFilter] = useState("no");
  const [popupaddateparameter, setpopupaddateparameter] = useState(false);
  const [popupremoveateparameter, setpopuppopupremoveateparameter] = useState(false);
  const [popupremovedateparameter, setpopupremovedateparameter] = useState();
  const [isChartSelected, setIsChartSelected] = useState(false);
  const [ischeckstartdate, setischeckstartdate] = useState(true);
  const [checkuploadlogo, setCheckUploadLogo] = useState("");
  const [loading, setLoading] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [messageShown, setMessageShown] = useState(false);

  const user = (() => {
    const encryptedData = localStorage.getItem("profile");
    return encryptedData ? decryptData(encryptedData) : null;
  })();
  const datacomefromprviewpage = JSON.parse(localStorage.getItem("backcustomeDetailOfReport"));
  const history = useNavigate(props);
  const dispatch = useDispatch();
  const [normalCustomQueryInputWidth, setNormalCustomQueryInputWidth] = useState(0);

  useEffect(() => {
    const normalCustomQueryInputDiv = document.getElementById(
      "normalCustomQueryInputId"
    );
    if (normalCustomQueryInputDiv) {
      const resizeObserver = new ResizeObserver(() => {
        const rect = normalCustomQueryInputDiv.getBoundingClientRect();
        setNormalCustomQueryInputWidth(rect.width);
      });

      resizeObserver.observe(normalCustomQueryInputDiv);
      return () => {
        resizeObserver.unobserve(normalCustomQueryInputDiv);
        resizeObserver.disconnect();
      };
    }
  }, []);

  const handleUploadLogoChange = (event) => {
    const checklogouploaded = event.target.value;
    if (event.target.value === "yes") {
      setCheckUploadLogo(checklogouploaded);
    } else {
      localStorage.removeItem("uploadLogo");
      setCheckUploadLogo(checklogouploaded);
      setformdata((prevData) => ({
        ...prevData,
        upload_logo: null
      }))
    }

  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file && file.type === "image/png" && file.size <= 1048576) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const base64String = event.target.result;
        localStorage.setItem("uploadLogo", base64String);
      };
      reader.readAsDataURL(file);
    } else {
      toast.success("Please select a PNG file with a maximum size of 1 MB.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    }
  };

  useEffect(() => {
    dispatch(
      getreporttitlefromondashbaord({
        database_type: user.database_type,
        email: user.user_email_id,
        customer_id: user.customer_id,
        group_id: user.group_id,
      })
    );
    dispatch(resettestquryonCustompage());
  }, []);

  const apiData = useSelector((state) => state);

  useEffect(() => {
    const datacomefromprviewpage = JSON.parse(
      localStorage.getItem("backcustomeDetailOfReport")
    );

    if (datacomefromprviewpage?.enable_drilldown === "yes") {
      setEnableDrilldown("yes");
    } else {
      setEnableDrilldown("no");
    }
    if (datacomefromprviewpage?.enable_range_filter === "yes") {
      setEnableRangeFilter("yes");
    } else {
      setEnableRangeFilter("no");
    }
    if (
      datacomefromprviewpage &&
      datacomefromprviewpage.report_type === "Chart"
    ) {
      setformdata((prevData) => ({
        ...prevData,
        title: datacomefromprviewpage?.report_template_name,
        query: datacomefromprviewpage?.defined_query,
        start_date: datacomefromprviewpage?.start_date,
        end_date: datacomefromprviewpage?.end_date,
        type: datacomefromprviewpage?.report_type,
        chart_type: datacomefromprviewpage?.chart_type,
        time_period: datacomefromprviewpage?.time_period,
        chart_colours: datacomefromprviewpage?.chart_colours,
        enable_drilldown: datacomefromprviewpage?.enable_drilldown,
        enable_range_filter: datacomefromprviewpage?.enable_range_filter,
        drilldown_type: datacomefromprviewpage?.drilldown_type,
        update_interval: datacomefromprviewpage?.auto_update_interval,
        connection_type: datacomefromprviewpage?.connection_type,
        report_id: datacomefromprviewpage?.report_id,
        schema: datacomefromprviewpage?.schema,
        chart_subtitle: datacomefromprviewpage?.chart_customizations_options?.chart_subtitle,
        enable_labels: datacomefromprviewpage?.enable_labels,
        custombox_background_colour: datacomefromprviewpage?.chart_customizations_options?.custombox_background_colour,
        custombox_title_font_size: datacomefromprviewpage?.chart_customizations_options?.custombox_title_font_size,
        custombox_value_font_size: datacomefromprviewpage?.chart_customizations_options?.custombox_value_font_size,
        custombox_font_colour: datacomefromprviewpage?.chart_customizations_options?.custombox_font_colour,
        custombox_legend_font_colour: datacomefromprviewpage?.chart_customizations_options?.custombox_legend_font_colour,
        custombox_legend_position: datacomefromprviewpage?.chart_customizations_options?.custombox_legend_position,
        display_title: datacomefromprviewpage?.chart_customizations_options?.display_title,
      }));
    } else if (
      datacomefromprviewpage &&
      datacomefromprviewpage.report_type === "Table"
    ) {
      setformdata((prevData) => ({
        ...prevData,
        title: datacomefromprviewpage?.report_template_name,
        query: datacomefromprviewpage?.defined_query,
        start_date: datacomefromprviewpage?.start_date,
        end_date: datacomefromprviewpage?.end_date,
        type: datacomefromprviewpage?.report_type,
        chart_type: datacomefromprviewpage?.chart_type,
        time_period: datacomefromprviewpage?.time_period,
        enable_drilldown: datacomefromprviewpage?.enable_drilldown,
        update_interval: datacomefromprviewpage?.auto_update_interval,
        connection_type: datacomefromprviewpage?.connection_type,
        report_id: datacomefromprviewpage?.report_id,
        schema: datacomefromprviewpage?.schema,
      }));
    } else if (
      datacomefromprviewpage &&
      datacomefromprviewpage.report_type === "Box"
    ) {
      if (datacomefromprviewpage.upload_logo != null) {
        setCheckUploadLogo("yes");
        setShowLogoSection(true);
      } else {
        setCheckUploadLogo("no");
        setShowLogoSection(true);
      }
      if (datacomefromprviewpage?.enable_range_filter === "yes") {
        setEnableRangeFilter("yes");
      } else {
        setEnableRangeFilter("no");
      }
      setformdata((prevData) => ({
        ...prevData,
        title: datacomefromprviewpage?.report_template_name,
        query: datacomefromprviewpage?.defined_query,
        start_date: datacomefromprviewpage?.start_date,
        end_date: datacomefromprviewpage?.end_date,
        type: datacomefromprviewpage?.report_type,
        chart_type: datacomefromprviewpage?.chart_type,
        time_period: datacomefromprviewpage?.time_period,
        background_colour: datacomefromprviewpage?.box_customization_options?.background_colour,
        chart_react_colour: datacomefromprviewpage?.box_customization_options?.chart_react_colour,
        font_size_title: datacomefromprviewpage?.box_customization_options?.font_size_title,
        font_size_value: datacomefromprviewpage?.box_customization_options?.font_size_value,
        gradient_mode: datacomefromprviewpage?.box_customization_options?.gradient_mode,
        layout: datacomefromprviewpage?.box_customization_options?.layout,
        layout_value: datacomefromprviewpage?.box_customization_options?.layout_value,
        subtitle: datacomefromprviewpage?.box_customization_options?.subtitle,
        subtitle_size: datacomefromprviewpage?.box_customization_options?.subtitle_size,
        subtitle_color: datacomefromprviewpage?.box_customization_options?.subtitle_color,
        subtitle_text: datacomefromprviewpage?.box_customization_options?.subtitle_text,
        text_alignment: datacomefromprviewpage?.box_customization_options?.text_alignment,
        enable_drilldown: datacomefromprviewpage?.enable_drilldown,
        enable_range_filter: datacomefromprviewpage?.enable_range_filter,
        drilldown_type: datacomefromprviewpage?.drilldown_type,
        update_interval: datacomefromprviewpage?.auto_update_interval,
        report_id: datacomefromprviewpage?.report_id,
        connection_type: datacomefromprviewpage?.connection_type,
        schema: datacomefromprviewpage?.schema,
        upload_logo: datacomefromprviewpage?.upload_logo,
        image_size:
          datacomefromprviewpage?.box_customization_options?.image_size,
        display_title: datacomefromprviewpage?.box_customization_options?.display_title,
      }));
    }
  }, []);

  const blurOnQueryTextArea = () => {
    setMessageShown(!messageShown);
  };

  useEffect(() => {
    if (
      datacomefromprviewpage?.connection_type &&
      datacomefromprviewpage?.schema &&
      !isTyping &&
      formdata?.query
    ) {
      console.log(
        datacomefromprviewpage?.connection_type,
        datacomefromprviewpage?.schema,
        "datacomefromprviewpage?.database_type"
      );
    }
  }, [datacomefromprviewpage, formdata?.query, user?.user_email_id, isTyping]);

  useEffect(() => {
    if (formdata.type === "Table" || formdata.type === "Box") {
      setformdata((prevData) => ({
        ...prevData,
        chart_type: "",
      }));
      if (isChartSelected) {
        setIsChartSelected(false);
      }
    }
    if (formdata.type === "Table") {
      setformdata((prevData) => ({
        ...prevData,
        enable_drilldown: "",
        enable_range_filter: "",
      }));
    }
  }, [formdata.type, isChartSelected]);

  const updateintervalset = (interval) => {
    const updateinterval = {
      1: 1,
      2: 2,
      3: 3,
      4: 4,
      5: 5,
    };
    return updateinterval[interval];
  };

  const handleRadioChange = (event) => {
    const chartTypes = {
      "Bar Chart": "bar",
      "Column Chart": "column",
      "Line Chart": "line",
      "Gauge Chart": "gauge",
      "Area Chart": "area",
      "Pie Chart": "pie",
      "Radial Bar Chart": "radialBar",
      "Stacked Area Chart": "stackarea",
      "Stacked Bar Chart": "stackbar",
      "Stacked Column Chart": "stackcolumn",
      "3d Pie Chart": "3Dpie",
      "3d Donut Chart": "3D Donut",
      "Donut Chart": "donut",
      "3d Area Chart": "3Darea",
      "speedometer": "speedometer",
      "drillcolumn": "drillcolumn",
      "custombox": "custombox",
    };
    const selectedChartType = chartTypes[event.target.value];

    if (selectedChartType) {
      setformdata({ ...formdata, [event.target.name]: selectedChartType });
      setShow(false);
      setIsChartSelected(true);
    }
  };
  const handleSubmit = (e) => {
    dispatch(resetbacktocustomquerypagewithdata());
    dispatch(setDrilldownTypeCheckdashboard(false))
    e.preventDefault();
    if (isTyping) {
      toast.success("Please test the query before previewing.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
      return;
    }
    if (formdata.title && formdata.query && formdata.type) {
      localStorage.setItem("customeDetailOfReport", JSON.stringify(formdata));
    } else {
      toast.success("Please fill the missing field", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    }

    history("/PreviewPage");
  };
  const handleTestQuery = async (e) => {
    e.preventDefault();
    setIsTyping(!isTyping);
    const query = formdata.query.trim().toLowerCase();
    if (query.startsWith("select") || query.startsWith("with")) {
      setLoading(true);
      try {
        dispatch(
          testquryonCustompage({
            query: formdata.query,
            schema: datacomefromprviewpage.schema,
            email: user.user_email_id,
            connection_type: datacomefromprviewpage.connection_type,
            database_type: user.database_type,
          })
        );
      } catch (error) {
        console.error("Error executing query:", error);
      } finally {
        setLoading(false);
      }
    } else {
      toast.success("Only Select Operation is allowed", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    }
  };

  const validationQuery = apiData?.auth.test_custom_query;
  const focusOnQueryTextArea = () => {
    if (!messageShown) {
      setIsTyping(true);
      setShowMessage(true);
      setMessageShown(true);
      setTimeout(() => {
        setShowMessage(false);
      }, 5000);
    }
  };
  const renderConditionalCharts = () => {
    if (
      validationQuery?.statusCode === 200 &&
      validationQuery?.column_count === 1
    ) {
      const gaugeAndSpeedometerCharts = charts.filter(
        (chart) => chart.id === "gauge" || chart.id === "speedometer"
      );
      return (
        <div
          className="form-group radBut"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 50,
            justifyContent: "center",
          }}
        >
          {renderCharts(gaugeAndSpeedometerCharts)}
        </div>
      );
    } else {
      let chartList = charts.filter(
        (chart) => chart.id !== "gauge" && chart.id !== "speedometer"
      );

      const isPieChartAllowed =
        validationQuery?.statusCode === 200 &&
        validationQuery?.column_count === 2 &&
        ["TEXT", "VARCHAR"].includes(validationQuery?.column_type[1]) &&
        ["INT", "FLOAT"].includes(validationQuery?.column_type[2]);

      if (isPieChartAllowed) {
        const pieCharts = charts.filter(
          (chart) =>
            chart.id === "pie" &&
            chart.id === "3d pie" &&
            chart.id === "3d donut" &&
            chart.id === "donut" &&
            chart.id === "drillcolumn" &&
            chart.id === "custombox"
        );
        chartList = [...chartList, ...pieCharts];
      } else {
        chartList = chartList.filter(
          (chart) =>
            chart.id !== "pie" &&
            chart.id !== "3d pie" &&
            chart.id !== "3d donut" &&
            chart.id !== "donut" &&
            chart.id !== "drillcolumn" &&
            chart.id !== "custombox"
        );
      }

      return (
        <div
          className="form-group radBut"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 50,
            justifyContent: "center",
          }}
        >
          {renderCharts(chartList)}
        </div>
      );
    }
  };
  function handleChangecharttype() {
    // setchartType(event.target.value)
    setShow((prev) => !prev);
  }
  const handleChange = (e) => {
    const lowerType = formdata?.type?.toString?.().toLowerCase();

    const shouldLimit =
      ["title", "name", "report_template_name"].includes(e.target.name) &&
      lowerType === "box";

    if (shouldLimit) {
      if (e.target.value.length > 45) {
        toast.warn("Title cannot exceed 45 characters for Box type", {
          position: "top-right",
          autoClose: 3000,
        });
        return; // prevent update
      }
    }
    if (e.target.name === "query") {
      dispatch(resettestquryonCustompage());
      setformdata({ ...formdata, [e.target.name]: e.target.value });
    } else if (e.target.name === "update_interval") {
      const interval = updateintervalset(e.target.value);

      setformdata({ ...formdata, [e.target.name]: interval });
    } else {
      setformdata({ ...formdata, [e.target.name]: e.target.value });
    }
  };

  const handleReportTypeChange = (event) => {
    setformdata({ ...formdata, chart_type: "" });
    setformdata({ ...formdata, type: event.target.value });

    if (event.target.value === "Table") {
      setShowLogoSection(true);
    } else {
      setShowLogoSection(false);
    }
  };
  const handleEnableDrilldownChange = (event) => {
    const enableDrilldownValue = event.target.value;
    setEnableDrilldown(enableDrilldownValue);
    setformdata((prevData) => ({
      ...prevData,
      enable_drilldown: enableDrilldownValue,
    }));
  };

  const handleEnableRangeChange = (event) => {
    const enablerangevalue = event.target.value;
    setEnableRangeFilter(enablerangevalue);
    setformdata((prevData) => ({
      ...prevData,
      enable_range_filter: enablerangevalue,
    }));
  };

  const handleclickgotoDashboard = () => {
    history("/Dashboard");
  };

  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShow(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  return (
    <div style={{ overflow: "clip" }}>
      {popupaddateparameter && (
        <Popupaddparameter
          formdata={formdata}
          setformdata={setformdata}
          setpopupaddateparameter={setpopupaddateparameter}
          setischeckstartdate={setischeckstartdate}
        />
      )}
      {popupremoveateparameter && (
        <PopupremoveDateParameter
          formdata={formdata}
          setformdata={setformdata}
          setpopuppopupremoveateparameter={setpopuppopupremoveateparameter}
        />
      )}
      {showModal && (
        <ChatBotModal
          setShowModal={setShowModal}
          handleClose={handleClose}
          setformdata={setformdata}
        />
      )}
      <div>
        <Header />
      </div>
      <div className="Custom_container">
        <div className="Custom_header_container">
          <span
            class="fas fa-house-user"
            aria-hidden="true"
            onClick={handleclickgotoDashboard}
          ></span>
          <span>/</span>
          <span>Create New Report</span>
        </div>
        <div className="customformpage">
          <form
            className="well form-horizontal"
            id="report_management"
            onSubmit={handleSubmit}
          >
            <fieldset>
              {/* <legend>
              <i className="glyphicon glyphicon-home"></i>Database Management
            </legend> */}

              <div class="mb-3 row">
                <label className="col-md-4 control-label testalinritemval">
                  Title
                </label>
                <div className="col-md-5 inputGroupContainer">
                  <div className="input-group flex-nowrap">
                    <span class="input-group-text" id="addon-wrapping">
                      <i class="fas fa-heading"></i>
                    </span>
                    <input
                      name="title"
                      placeholder="e.g. Incident Severity"
                      className="form-control"
                      type="text"
                      value={formdata.title}
                      maxLength={38}
                      minLength={5}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="mb-3 row">
                <label className="col-md-4 control-label testalinritemval">
                  Query
                </label>
                <div className="col-md-5 inputGroupContainer">
                  <div class="input-group flex-nowrap">
                    <span class="input-group-text" id="addon-wrapping">
                      <i class="fas fa-edit"></i>
                    </span>
                    <textarea
                      name="query"
                      placeholder="Query"
                      value={formdata.query}
                      className="form-control query-section-textarea"
                      onFocus={focusOnQueryTextArea}
                      onBlur={blurOnQueryTextArea}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </div>
                <img
                  className="chart_bot_icon"
                  src={bot}
                  onClick={handleClose}
                  title="Write your query"
                />
                {showMessage && (
                  <div class="alert-for-update-custom-query">
                    <span class="alert-icon">⚠️</span>
                    <span class="alert-message">
                      Please click the test query button after typing to
                      validate your query.
                    </span>
                    <button class="close-btn" aria-label="Close alert">
                      &times;
                    </button>
                  </div>
                )}
              </div>
              <div className="mb-3 row col-md-5`input-group param_button">
                <Button
                  type="button"
                  disabled={validationQuery?.statusCode !== 200}
                  onClick={() => {
                    setpopupremovedateparameter();
                    setpopupaddateparameter(true);
                  }}
                >
                  Add Date Parameter
                </Button>

                <Button
                  type="button"
                  disabled={
                    !(
                      validationQuery?.statusCode === 200 &&
                      formdata.start_date !== "" &&
                      formdata.end_date !== ""
                    )
                  }
                  onClick={() => {
                    setpopupremovedateparameter();
                    setpopuppopupremoveateparameter(true);
                  }}
                >
                  Remove Date Parameter
                </Button>
                <Button type="button" onClick={handleTestQuery} >
                  {loading ? (
                    <span>
                      Testing...
                    </span>
                  ) : (
                    "Test Query"
                  )}
                </Button>
              </div>
              <div style={{ textAlign: "center" }}>
                {!isTyping &&
                  validationQuery &&
                  validationQuery?.detail === "Valid Query" ? (
                  <p>
                    <i
                      style={{
                        backgroundColor: "green",
                        fontSize: "18px",
                        width: "25px",
                        height: "15px",
                        borderRadius: "50%",
                      }}
                      class="fa-solid fa-check"
                    ></i>
                    {validationQuery?.detail}
                  </p>
                ) : validationQuery?.statusCode === 400 ||
                  validationQuery?.statusCode === 401 ? (
                  !isTyping &&
                  validationQuery && (
                    <p>
                      <i
                        style={{
                          backgroundColor: "red",
                          fontSize: "18px",
                          width: "25px",
                          height: "15px",
                          borderRadius: "50%",
                        }}
                        class="fa-solid fa-smark"
                      ></i>
                      <span>{validationQuery?.detail}</span>
                    </p>
                  )
                ) : (
                  !isTyping &&
                  validationQuery && (
                    <p>
                      <i
                        style={{
                          backgroundColor: "yellow",
                          fontSize: "18px",
                          width: "25px",
                          height: "15px",
                          borderRadius: "50%",
                        }}
                        class="fa-solid fa-smark"
                      ></i>
                      {validationQuery?.detail}
                    </p>
                  )
                )}
              </div>
              <div className="mb-3 row">
                <label className="col-md-4 control-label testalinritemval">
                  Start Date
                </label>
                <div
                  className="col-md-5 inputGroupContainer"
                  id="normalCustomQueryInputId"
                >
                  <div class="input-group flex-nowrap">
                    <span class="input-group-text" id="addon-wrapping">
                      <i class="fas fa-calendar"></i>
                    </span>
                    <input
                      type="date"
                      name="start_date"
                      class="form-control"
                      disabled={ischeckstartdate}
                      placeholder="Start Date"
                      aria-label="Username"
                      aria-describedby="addon-wrapping"
                      value={formdata.start_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="mb-3 row">
                <label className="col-md-4 control-label testalinritemval">
                  End Date
                </label>
                <div className="col-md-5 inputGroupContainer">
                  <div class="input-group flex-nowrap">
                    <span class="input-group-text" id="addon-wrapping">
                      <i class="fas fa-calendar"></i>
                    </span>
                    <input
                      type="date"
                      name="end_date"
                      class="form-control"
                      disabled={ischeckstartdate}
                      placeholder="end_date"
                      aria-label="Username"
                      aria-describedby="addon-wrapping"
                      value={formdata.end_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="mb-3 row">
                <label className="col-md-4 control-label testalinritemval">
                  Type
                </label>
                <div className="col-md-5 selectContainer">
                  <div class="input-group flex-nowrap">
                    <span class="input-group-text" id="addon-wrapping">
                      <i class="fas fa-file-alt"></i>
                    </span>
                    <select
                      name="type"
                      className="form-control selectpicker"
                      disabled={validationQuery?.statusCode != 200}
                      onChange={handleReportTypeChange}
                      value={formdata.type}
                      required
                    >
                      <option value="" disabled selected hidden>
                        Report Type
                      </option>
                      {validationQuery?.statusCode === 200 &&
                        validationQuery?.column_count > 1 && (
                          <option>Table</option>
                        )}
                      <option>Chart</option>
                      {validationQuery?.statusCode === 200 &&
                        validationQuery?.column_count === 1 && (
                          <option>Box</option>
                        )}
                    </select>
                  </div>
                </div>
              </div>

              <div className="mb-3 row">
                <label className="col-md-4 control-label testalinritemval">
                  Chart Type
                </label>
                <div className="col-md-5 selectContainer">
                  <div className="input-group flex-nowrap" ref={wrapperRef}>
                    <span class="input-group-text" id="addon-wrapping">
                      <i class="fas fa-chart-bar"></i>
                    </span>
                    <div style={{ minWidth: normalCustomQueryInputWidth - 56 }}>
                      <textarea
                        name="chart_type"
                        value={formdata.chart_type}
                        className="form-control textArea-chart-type"
                        onClick={handleChangecharttype}
                        placeholder="Chart Type"
                        required={
                          formdata.type !== "Table" && formdata.type !== "Box"
                        }
                        disabled={
                          validationQuery?.statusCode !== 200 ||
                          formdata.type !== "Chart"
                        }
                        style={{
                          height: "34px",
                          resize: true,
                          width: "100%",
                          borderTopLeftRadius: "0",
                          borderBottomLeftRadius: "0",
                        }}
                      ></textarea>
                      {show && <div> {renderConditionalCharts()}</div>}
                    </div>
                  </div>
                </div>
              </div>
              {(formdata.type === "Chart" || formdata.type === "Box") && (
                <div className="mb-3 row">
                  <label className="col-md-4 control-label testalinritemval">
                    Enable Drilldown
                  </label>
                  <div className="radio col-md-2 display_radio">
                    <label className="radio-inline">
                      <input
                        type="radio"
                        name="enableDrilldown"
                        value="yes"
                        onChange={handleEnableDrilldownChange}
                        checked={
                          enableDrilldown === "yes" ||
                          formdata.enable_drilldown === "yes"
                        }
                        disabled={
                          !formdata?.query.toLowerCase().includes("group by") &&
                          formdata.type !== "Box"
                        }
                      />{" "}
                      Yes
                    </label>
                    <label className="radio-inline">
                      <input
                        type="radio"
                        name="enableDrilldown"
                        value="no"
                        onChange={handleEnableDrilldownChange}
                        checked={
                          enableDrilldown === "no" ||
                          formdata.enable_drilldown === "no"
                        }
                        disabled={
                          !(
                            formdata?.type === "Box" ||
                            formdata?.query?.toLowerCase().includes("group by")
                          )
                        }
                      />{" "}
                      No
                    </label>
                  </div>
                </div>
              )}
              {(formdata.type === "Chart" || formdata.type === "Box") && (
                <div className="mb-3 row">
                  <label className="col-md-4 control-label testalinritemval">
                    Enable Range Filter
                  </label>
                  <div className="radio col-md-2 display_radio">
                    <label className="radio-inline">
                      <input
                        type="radio"
                        name="enablerangefilter"
                        value="yes"
                        onChange={handleEnableRangeChange}
                        checked={
                          enablerangefilter === "yes" ||
                          formdata.enable_range_filter === "yes"
                        }
                        disabled={
                          !formdata?.query.toLowerCase().includes("group by") &&
                          formdata.type !== "Box"
                        }
                      />{" "}
                      Yes
                    </label>
                    <label className="radio-inline">
                      <input
                        type="radio"
                        name="enablerangefilter"
                        value="no"
                        onChange={handleEnableRangeChange}
                        checked={
                          enablerangefilter === "no" ||
                          formdata.enable_range_filter === "no"
                        }
                        disabled={
                          !(
                            formdata?.type === "Box" ||
                            formdata?.query?.toLowerCase().includes("group by")
                          )
                        }
                      />{" "}
                      No
                    </label>
                  </div>
                </div>
              )}
              {showLogoSection && formdata.type === "Box" && (
                <div className="mb-3 row" style={{ alignItems: "center" }}>
                  <label className="col-md-4 control-label testalinritemval">
                    Upload logo
                  </label>
                  <div className="radio col-md-2 display_radio">
                    <label className="radio-inline">
                      <input
                        type="radio"
                        checked={checkuploadlogo === "yes"}
                        name="hosting3"
                        value="yes"
                        onChange={handleUploadLogoChange}
                      />{" "}
                      Yes
                    </label>
                    <label className="radio-inline">
                      <input
                        type="radio"
                        name="hosting3"
                        checked={checkuploadlogo === "no"}
                        value="no"
                        onChange={handleUploadLogoChange}
                      />{" "}
                      No
                    </label>
                    {checkuploadlogo === "yes" && (
                      <label>
                        <input
                          name="file"
                          onChange={handleFileChange}
                          type="file"
                          accept="image/png"
                        />
                      </label>
                    )}
                  </div>
                </div>
              )}
              <div className="mb-3 row">
                <label className="col-md-4 control-label testalinritemval">
                  Auto Update Interval
                </label>
                <div className="col-md-5 selectContainer">
                  <div className="input-group flex-nowrap">
                    <span class="input-group-text" id="addon-wrapping">
                      <i class="fas fa-hourglass-half"></i>
                    </span>

                    <select
                      name="update_interval"
                      required
                      className="form-control selectpicker"
                      disabled={validationQuery?.statusCode != 200}
                      value={formdata.update_interval}
                      onChange={handleChange}
                    >
                      <option value="" disabled hidden>
                        Minute(s)
                      </option>
                      <option value="1">1 minute</option>
                      <option value="2">2 minutes</option>
                      <option value="3">3 minutes</option>
                      <option value="4">4 minutes</option>
                      <option value="5">5 minutes</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="mb-3 row" style={{ justifyContent: "center" }}>
                <div className="col-md-4" style={{ paddingLeft: "125px" }}>
                  <Button
                    disabled={validationQuery?.statusCode != 200}
                    type="submit"
                  >
                    Preview
                  </Button>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  );
}
